<div class="goal-targets-panel-container">
    @if (goalTargetForms) {
        @for(goalTargetForm of goalTargetForms.controls; track goalTargetForm.controls.goalId.value) {

            <div class="goal-panel">
                <mat-expansion-panel [expanded]="isGoalExpanded(goalTargetForm.controls.goalId.value)"
                    (opened)="goalExpanded(goalTargetForm.controls.goalId.value)"
                    (closed)="goalCollapsed(goalTargetForm.controls.goalId.value)"
                    >
                    <mat-expansion-panel-header>
                        <span class="goal-name">
                            {{goalTargetForm.controls.goal.value.name}}

                            @if (goalTargetForm.controls.goal.value.themeSubArea) {
                                - {{goalTargetForm.controls.goal.value.themeSubArea}}
                            }
                        </span>
                        &nbsp;
                        <span class="goal-unit" [innerHtml]="'(Metric Unit: ' + goalTargetForm.value.metricTargets[0].outcomeMetric.preferredUnit.name + ')'"></span>
                    </mat-expansion-panel-header>

                    <div class="goal-target" [formGroup]="goalTargetForm">
                        <div class="goal-target-panel">
                            <div class="numeric-inputs-row">
                                <div>
                                    <div class="cell-label">Target&nbsp;ID</div>
                                    <div class="cell-value">{{goalTargetForm.controls.uniqueId.value}}</div>
                                </div>
                                <div>
                                    <div class="cell-label">Target Date</div>
                                    <div>
                                        <mat-form-field>
                                            <input matInput readonly formControlName="targetDate" (click)="targetDatePicker.open()" [matDatepicker]="targetDatePicker">
                                            <mat-datepicker-toggle matIconSuffix [for]="targetDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #targetDatePicker></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                    <div class="hub-validation-error-message"[innerHtml]="getLocalValidationErrorMessages(goalTargetForm, 'targetDate')"></div>
                                </div>
                                <div>
                                    <div class="cell-label">Target Value</div>
                                    <div>
                                        <mat-form-field>
                                            <input matInput class="form-control" type="number" formControlName="targetValue" />
                                        </mat-form-field>
                                    </div>
                                    <div class="hub-validation-error-message"[innerHtml]="getLocalValidationErrorMessages(goalTargetForm, 'targetValue')"></div>
                                </div>
                                <div class="target-unit">
                                    <div [innerHtml]="goalTargetForm.value.metricTargets[0].outcomeMetric.preferredUnit.name"></div>
                                </div>

                            </div>

                            <div class="text-input-row">
                                <div class="cell-label" style="margin-bottom: 20px;">Target Statement</div>
                                <textarea rows="3" formControlName="targetStatement"></textarea>
                                <div class="hub-validation-error-message"[innerHtml]="getLocalValidationErrorMessages(goalTargetForm, 'targetStatement')"></div>
                            </div>
                        </div>

                        <div class="metric-targets-panel" formArrayName="metricTargets">
                            <span class="goal-name">{{goalTargetForm.controls.goal.name}} Metric Targets</span>
                            &nbsp;
                            <span class="goal-unit" [innerHtml]="'(Metric Unit: ' + goalTargetForm.controls.metricTargets.value[0].outcomeMetric.preferredUnit.name + ')'"></span>

                            @for (metricTarget of goalTargetForm.controls.metricTargets.controls; track metricTarget.controls.outcomeMetricId.value; let i = $index) {
                                <div class="metric-target">
                                    <div class="metric-target-heading">
                                        {{i + 1}}. {{metricTarget.controls.outcomeMetric.value.name}}
                                    </div>
                                    <div class="metric-target-panel" [formGroupName]="i">

                                        <div class="numeric-inputs-row">
                                            <div class="target-id">
                                                <div class="cell-label">Target ID</div>
                                                <div class="cell-value">{{metricTarget.controls.uniqueId.value}}</div>
                                            </div>
                                            <div class="target-date">
                                                <div class="cell-label">Target Date</div>
                                                <div>
                                                    <mat-form-field>
                                                        <input matInput readonly formControlName="targetDate" (click)="metricTargetDatePicker.open()" [matDatepicker]="metricTargetDatePicker">
                                                        <mat-datepicker-toggle matIconSuffix [for]="metricTargetDatePicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #metricTargetDatePicker></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                                <div class="hub-validation-error-message"[innerHtml]="getLocalValidationErrorMessages(metricTarget, 'targetDate')"></div>
                                            </div>

                                            <div class="target-value">
                                                <div class="cell-label">Target Value</div>
                                                <div>
                                                    <mat-form-field>
                                                        <input matInput class="form-control" type="number" formControlName="targetValue" />
                                                    </mat-form-field>
                                                </div>
                                                <div class="hub-validation-error-message"[innerHtml]="getLocalValidationErrorMessages(metricTarget, 'targetValue')"></div>
                                            </div>

                                            <div class="target-unit">
                                                <div [innerHtml]="metricTarget.value.outcomeMetric.preferredUnit.name"></div>
                                            </div>
                                        </div>

                                        <div class="text-input-row">
                                            <div class="cell-label" style="margin-bottom: 20px;">Target Statement</div>
                                            <textarea rows="3" formControlName="targetStatement"></textarea>
                                        </div>

                                    </div>
                                </div>
                            }

                        </div>
                    </div>


                </mat-expansion-panel>
            </div>
        }
    }
</div>
